import { ExternalChatUser, isExternalChatUser } from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { FirestoreWhere, useCollectionStore } from "Helpers/StoreHelper";
import { firestore } from "firebase/app";
import { useRef } from "react";

export function useUsersStore(organizationId: string, userId: string) {
  const collectionRef = useRef(
    firestore()
      .collection(CollectionPath.ORGANIZATIONS)
      .doc(organizationId)
      .collection(CollectionPath.USERS)
  );

  const sortRef = useRef((a: ExternalChatUser, b: ExternalChatUser) =>
    a.name.localeCompare(b.name)
  );

  const whereRef = useRef<FirestoreWhere[]>([["internalId", "==", userId]]);

  return useCollectionStore<ExternalChatUser>({
    collection: collectionRef.current,
    is: isExternalChatUser,
    sort: sortRef.current,
    where: whereRef.current,
  });
}
